import { apiCall, createQueryString } from "./../imports";
const PREFIX = "management/drivers";

export default {
  getDrivers(data) {
    return apiCall("get", `${PREFIX}${createQueryString(data)}`);
  },

  deleteDrivers(id) {
    return apiCall("delete", `${PREFIX}/${id}`);
  },
};
